export const SAMPLE_DATA = [
  { name: "Blue", code: "BLUE" },
  { name: "Green", code: "GREEN" },
  { name: "Red", code: "RED" },
];
